import XTbl,{Xtc} from '../../components/x-table/index';
const tbl = new XTbl('/task/task-list/query/', 'task list');

tbl.add(new Xtc('title', 'Title').renderSlot('task_title'))
tbl.add(new Xtc('description', 'Description'))
tbl.add(new Xtc('practice_area.title', 'Practice Area'))
tbl.add(new Xtc('action', 'Action').noSort().renderSlot('action'))

export default tbl;

